module.exports = __webpack_public_path__ + "img/ava_ad1x3.e16966b6.png";